import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector } from 'react-redux';
import { formatChartDate, getBoundaryTimestamps } from '@/shared/utils/dateFormatters';
import BarChart from '@/shared/ui/charts/BarChart';
import { useGetSharesQuery } from '@/shared/api/Shares';
import { 
  selectDateRange,
  selectPollingInterval, 
} from "@/processes/Settings";
import { useMinerAccount } from "@/processes/MinerAccounts";

type SharesChartProps = {
  workerName?: string;
  className?: string;
  visibleChartBars?: string[];
}

const SharesChart = (props: SharesChartProps) => {
  const { 
    className, 
    workerName = '',
    visibleChartBars = [],
  } = props;
  const intl = useIntl();
  const dateRange = useSelector(selectDateRange);
  const pollingInterval = useSelector(selectPollingInterval);
  const { account, miner, coin } = useMinerAccount();

  const { data: sharesData = [], isSuccess } = useGetSharesQuery({ 
    coin,
    account,
    miner,
    dateRange,
    worker: workerName,
  }, { pollingInterval, skip: !(account || miner) });

  const lines = [
    {
      name: intl.formatMessage({ id: 'shares.rejected' }),
      dataKey: "invalidCount",
      stroke: "#FF504C",
    },
    {
      name: intl.formatMessage({ id: 'shares.valid' }),
      dataKey: "validCount",
      stroke: "#00CCAA",
    },
  ].filter((line: any) => {
    return visibleChartBars.length > 0 
      ? visibleChartBars.includes(line.dataKey) 
      : true
  });

  return (
    <>
      <BarChart
        className="w-full h-[180px] mt-6"
        data={sharesData}
        XAxisProps={{
          dataKey: 'timestamp',
          formatter: (value) => formatChartDate({ date: value, locale: intl.locale, dateRange, ...getBoundaryTimestamps(sharesData) }),
        }}
        YAxisProps={{
          dataKey: visibleChartBars.length && !visibleChartBars.includes('validCount') ? visibleChartBars[0] : 'validCount',
        }}
        tooltipLabelFormatter={(value) => formatChartDate({ date: value, locale: intl.locale })}
        lines={lines}
      />
    </>
  );
}

export default SharesChart;
